import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Input,
  Select,
  Switch,
  Upload,
  Icon,
  AutoComplete,
  Divider,
  Radio,
  Checkbox,
  Table,
  DatePicker,
  InputNumber,
  Row,
  Col,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import * as _ from "lodash";
import CodeEditor from "../../../../../../helpers/CodeEditor2";
import { Modal } from "../../../../../../helpers/commonUi";
import { updateFormProperties } from "../../../../../../stateManager/store/formCreation/action";
import { updateAssetProperties } from "../../../../../../stateManager/store/assets/action";
import { IProperties } from "./properity";
import style from "./props.module.sass";
import { findIdSelector } from "../reduxSelector";
import { ReactComponent as Picker } from "../../../../../../assets/svg/themeSelector.svg";
import { getFunctions } from "./commonFunctions";
import tabName from "../../../../../../assets/svg/tab_ico.svg";
import typeName from "../../../../../../assets/svg/type_ico.svg";
import { RadioChangeEvent } from "antd/lib/radio";
import moment from 'moment'
import ColorPicker from "../../../../../../helpers/commonUi/ColorPicker";
import { useDebouncedAction, assetSelector } from '../../../../../../helpers/commonFunction'
import TarsLayout from "./TarsLayout";
import I18AutoCompletion from "./I18NAutoComplete";
import CustomAutoComplete from "./customAutoComplete";
import { AppState } from "../../../../../../stateManager/store";

const { Option } = Select;

export const Properties: React.FC<IProperties> = (props) => {
  const id = props.json && props.json.id;
  const params: any = useParams();

  const [functionsdef, setFunctionsdef] = useState<any>();
  const dispatch = useDispatch();
  const version = useSelector(
    (state: any) => state.apps.appVersion[params["appId"]]
  );
  const [selectKey, setSelectKey] = useState<any[]>([]);

  const selectedAssetId = useSelector((state: any) => state.assets.selectedAssetId);
  const assets = useSelector((state: any) => state.assets.list);
  const assetEditMode = useSelector((state: any) => state.assets.assetEditMode);
  let json = useSelector((state: any) =>
    id ? findIdSelector(state, params.formId, id.split("#"), true) : []
  );
  const formData = useSelector((state: AppState) => state.formcreation[params.formId]);

  json = assetEditMode ? assetSelector(assets[selectedAssetId], id!.split("#")) : json;

  let type = "";
  let properties: any = {}
  let name = "";
  let tabKey = "";
  let elementId = "";
  let bind = "";
  let label = "";

  if (json) {
    type = json.type;
    properties = json.properties;
    label = json.label;
    name = json.name;
    tabKey = json.tabKey;
    elementId = json.elementId;
    bind = json.bind;
  }
  
  // const { type, properties, name, tabKey, elementId, bind } = json
  const onTabSwitchCode = properties &&
    properties.onTabSwitch &&
    properties.onTabSwitch!.fun
    ? properties.onTabSwitch!.fun
    : `async function main(${type === "InputGroup" ? "value" : ""
    }) { 
  // Start of editable area
  
  // End of editable area
}`

  const onTaskEventCode = properties &&
    properties.onTaskEvent &&
    properties.onTaskEvent!.fun
    ? properties.onTaskEvent!.fun
    : `async function main(event) { 
        // Start of editable area

        // End of editable area
      }`


  const [labelValue, setLabelValue] = useDebouncedAction(type === "TabBar" ? name : properties && properties.label || label)
  const [keyTitleValue, setKeyTitleValue] = useDebouncedAction(properties && properties.keyTitle)
  const [valueTitleValue, setValueTitleValue] = useDebouncedAction(properties && properties.valueTitle)
  const [placeholderValue, setPlaceholderValue] = useDebouncedAction(properties && properties.placeholder)
  const [visibilityValue, setVisibilityValue] = useDebouncedAction(properties && properties.visibility && properties.visibility.condition)
  const [formatValue, setFormatValue] = useDebouncedAction(properties && properties.format)
  const [tabKeyValue, setTabKeyValue] = useDebouncedAction(tabKey)
  const [buttonTextValue, setButtonTextValue] = useDebouncedAction(properties && properties.buttonText)
  const [idValue, setIdValue] = useDebouncedAction(elementId)
  const [bindText, setBindText] = useDebouncedAction(bind)
  const [datePlaceholderValue, setDatePlaceholderValue] = useDebouncedAction(Array.isArray(properties && properties.placeholder) ? properties && properties.placeholder[0] : "Start Date")
  const [datePlaceholderToValue, setDatePlaceholderToValue] = useDebouncedAction(Array.isArray(properties && properties.placeholder) ? properties && properties.placeholder[1] : "End Date")
  const [parseBindVar, setParseBindVar] = useDebouncedAction(properties && properties.parseBindVar)

  const [visible, setVisible] = useState<boolean>(false);
  const [isChangeModalvisible, setChangeModalVisible] = useState<boolean>(
    false
  );
  const [selectedHandlerType, setSelectedHandlerType] = useState<string>("");
  const [tabBgImage, setTabBgImage] = useState(false);
  const [fromDatePickerError, setFromDatePickerError] = useState(false);
  const [toDatePickerError, setToDatePickerError] = useState(false);
  const [toTypeError, setToTypeError] = useState(false);
  const [fromTypeError, setFromTypeError] = useState(false);
  const [toNumberError, setToNumberError] = useState(false);
  const [fromNumberError, setFromNumberError] = useState(false);

  const [selectedBgImage, setSelectedBgImage] = useState("");
  const [restrictUseEffect, setRestrictUseEffect] = useState(true);
  const [
    stateAutoCompleteVariables,
    setStateAutoCompleteVariables,
  ]: any[] = useState([]);
  const [AutoCompleteResult, setAutoCompleteResult]: any[] = useState([]);
  const selectedAppType = useSelector(
    (state: any) => state.apps.selectedApp.type
  );
  const autoCompleteAndLocalVariables = useSelector((state: any) => {
    return {
      localVariables: state.formcreation[params.formId],
      autocompleteVariables: state.formcreation.autoCompleteVariables,
    };
  });
  const [bindErr, setBindErr] = useState<boolean>(false);
  const editorRef = useRef(null);
  const [currentLine, setCurrentLine] = useState(3);
  const [tarsModal, setTarsModal] = useState(false)

  useEffect(() => {
    json && json.data && json.data.options && setSelectKey(json.data.options);
  }, [selectKey, json]);
  // const onBlur = (data: any, key: string) => {

  // }
  useEffect(() => {
    if (restrictUseEffect) {
      const bindForms = (
        fields: any[],
        tabDetails: any,
        name: string,
        data: any[]
      ) => {
        _.each(fields, (fieldValue) => {
          if (fieldValue.bind) {
            data.push({
              ...tabDetails,
              name,
              ...fieldValue,
            });
          } else if (fieldValue.fields) {
            data = bindForms(
              fieldValue.fields,
              tabDetails,
              name,
              data
            );
          }
        });

        return data;
      };

      let formName =
        props.selectedFormData &&
        !!props.selectedFormData.length &&
        props.selectedFormData[0].formName;

      let responseData: any[] = [];
      _.each(autoCompleteAndLocalVariables.localVariables, (sValue) => {
        responseData = bindForms(
          sValue.fields,
          { tabName: sValue.name, tabId: sValue.id, tabKey: sValue.tabKey },
          formName,
          responseData
        );
      });

      setStateAutoCompleteVariables([
        ...responseData,
        ...autoCompleteAndLocalVariables.autocompleteVariables,
      ]);
      setRestrictUseEffect(false);
    }
  }, [
    props.selectedFormData,
    autoCompleteAndLocalVariables.autocompleteVariables,
    autoCompleteAndLocalVariables.localVariables,
    restrictUseEffect,
  ]);

  const [labelBlur, setLabelBlur] = useState(true);

  const onChange = async (data: any, key: string) => {
    if (props.canEdit) {
      const setData = _.setWith({}, key, data, Object);
      if (assetEditMode && selectedAssetId) {
        dispatch(
          updateAssetProperties({
            assetId: selectedAssetId,
            id,
            data: setData,
          })
        );
      } else {
        dispatch(
          updateFormProperties({
            formid: params.formId,
            id: json.id,
            data: setData,
          })
        );
      }
    }
  };

  const onChangeAsync = async (data: any, key: string) => {
    if (props.canEdit) {
      const setData = _.setWith({}, key, data, Object);
      if (assetEditMode && selectedAssetId) {
        dispatch(
          updateAssetProperties({
            assetId: selectedAssetId,
            id,
            data: setData,
          })
        );
      } else {
        dispatch(
          updateFormProperties({
            formid: params.formId,
            id: json.id,
            data: setData,
          })
        );
      }
    }
  };

  const openCodeEditorModal = async () => {
    try {
      let data = await getFunctions(params["appId"], version.versionId);
      setFunctionsdef(data);
    } catch (e) { }
    setVisible(true);
  };

  const openChangeModal = async (selectedType: string) => {
    try {
      let data = await getFunctions(params["appId"], version.versionId);
      setFunctionsdef(data);
    } catch (e) { }
    setSelectedHandlerType(selectedType);
    setChangeModalVisible(true);
  };

  const getBase64 = (file: File, callback: Function) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(file);
  };

  const handleBgImageChange = ({ file }: any) => {
    getBase64(file.originFileObj, (base64: string) => {
      setSelectedBgImage(base64);
      onChange(base64, "backgroundImage");
      onChange(null, "backgroundColor");
    });
  };

  const handleBgColor = (e: any) => {
    onChange(e.target.value, "backgroundColor");
    setSelectedBgImage("");
    onChange(null, "backgroundImage");
  };
  const handleSearch = (searchId: string) => (value: any) => {
    let result: any[];
    if (!value) {
      result = [];
    } else {
      result = stateAutoCompleteVariables.filter((variables: any) => {
        let formName =
          props.selectedFormData && props.selectedFormData[0].formName;
        return formName === variables.formName && searchId === variables.id
          ? false
          : variables.bind.toUpperCase().indexOf(value.toUpperCase()) > -1;
      });
    }
    setAutoCompleteResult(result);
    // AutoCompleteResult

    // this.setState({ result });
  };


  const autoCompleteChildren = () => {
    return AutoCompleteResult.slice(0, 10).map((variable: any, key: number) => {
      let formName =
        props.selectedFormData && props.selectedFormData[0].formName;
      return (
        <AutoComplete.Option key={key} label={variable.bind}>
          <div
          // style={{ border: "solid 1px #dee5f4", backgroundColor: "#f8fbff", borderRadius: "4px" }}
          >
            <ul key={key} style={{ listStyleType: "none", padding: "0px 0px" }}>
              <li>
                <span
                  style={{
                    color: "#000000",
                    fontSize: "14px",
                    fontWeight: 700,
                    paddingTop: "11px",
                  }}
                >
                  {variable.bind}
                </span>
              </li>
              <li>
                <span style={{ color: "#666980", paddingTop: "5px" }}>
                  {variable.formName}
                  {formName === variable.formName && "(current)"}
                </span>
              </li>
              <li>
                <span
                  style={{
                    color: "#FF5797",
                    paddingTop: "7px",
                    paddingRight: "6px",
                  }}
                >
                  <img src={tabName} alt={"tabname"} />
                </span>
                <span style={{ color: "#FF5797" }}>{variable.tabName}</span>
              </li>
              <li>
                <span
                  style={{
                    color: "#95abd3",
                    paddingTop: "7px",
                    paddingRight: "6px",
                    paddingBottom: "13px",
                  }}
                >
                  <img src={typeName} alt={"typename"} />
                </span>
                <span style={{ color: "#4993FD" }}>{variable.type}</span>
              </li>{" "}
            </ul>
            <Divider style={{ margin: "13px 0px 0px 0px" }}></Divider>
          </div>
        </AutoComplete.Option>
      );
    });
  };

  const renderBindComponent = () => {
    return (
      <Form.Item label="Bind" className={"a8-form-item props"} hasFeedback>
        <AutoComplete
          data-test-id="property_bind"
          dropdownMenuStyle={{ height: "338px", maxHeight: "350px" }}
          style={{ width: "100%" }}
          disabled={!props.canEdit}
          onChange={(text: any) => {
            if (text !== "." && (text === '' || isNaN(text))) {
              let modifiedText: string;
              const textSplit = text.split(".");
              handleSearch(json.id)(text);
              if (textSplit.length >= 3) {
                !bindErr && setBindErr(true);
                modifiedText = `${textSplit[0]}.${textSplit[1]}`.replace(/\s/g, "")
              } else {
                bindErr && setBindErr(false)
                modifiedText = text.replace(/\s/g, "")
              }
              setBindText(modifiedText, () => onChange(modifiedText, "bind"))
            }
          }}
          onFocus={() => {
            handleSearch(json.id)(bind);
          }}
          placeholder="Bind"
          className={style.borderRemove}
          value={bindText}
          onSelect={(_inputValue, option: any) => {
            const { label } = option.props;
            handleSearch(json.id)(label);
            onChange(label.replace(/\s/g, ""), "bind");
            setBindText(label.replace(/\s/g, ""))
          }}
          optionLabelProp="label"
        >
          {autoCompleteChildren()}
        </AutoComplete>
        {bindErr && (
          <div className={style.bindError}>
            Bind value cannot be nested more than once
          </div>
        )}
      </Form.Item>
    );
  };

  const handleMultipleScannerBind = (values: string[]) => {
    let bindVariables: any = {};
    values.forEach((val) => {
      let scannerOption = scannerOptions.find((x) => x.value === val);
      if (scannerOption) {
        bindVariables[val] = { ...scannerOption };
      }
    });
    //{ label: 'Aadhaar', value: 'aadhaar', docType: "AADHAR", parse: true, mask: ["aadharNumber"] },
    onChange(bindVariables, "properties.bindVariables");
  };

  const scannerOptions = [
    { label: "Aadhar Front", value: "aadhar_front", docType: "AADHAR_FRONT" },
    { label: "Aadhar Back", value: "aadhar_back", docType: "AADHAR_BACK" },
    { label: "PAN", value: "pan", docType: "PAN" },
    { label: "Driving License", value: "dl", docType: "DL" },
    { label: "Passport", value: "passport", docType: "PASSPORT" },
    { label: "Voter Id", value: "voterId", docType: "VOTERID" },
    {
      label: "Single KYC Approval", value: "singleKYCApproval", docType: "IMG"
    },
    { label: "QR", value: "qr", docType: "QR" },
    { label: "Image", value: "image", docType: "IMG" },
    { label: "Cheque", value: "cheque", docType: "CHEQUE" },
  ];

  const ParseBindVar: any = {
    PAN: [
      { key: "name", label: "name" },
      { key: "accountNumber", label: "Account Number" },
      { key: "dob", label: "Date of Birth" },
      { key: "fathersName", label: "Father's Name" },
    ],
    AADHAR: [
      { key: "aadharNumber", label: "Aadhar Number" },
      { key: "dob", label: "Date of Birth" },
      { key: "checksum_status", label: "Checksum Status" },
      { key: "gender", label: "Gender" },
      { key: "name", label: "Name" },
      { key: "pincode", label: "PinCode" },
      { key: "state", label: "State" },
      { key: "address", label: "Address" },
    ],
    DL: [
      { key: "dlId", label: "License Id" },
      { key: "dateOfBirth", label: "Date of Birth" },
      { key: "dateOfExpiryNT", label: "Date Of Expiry NT" },
      { key: "dateOfExpiryT", label: "Date of Expiry T" },
      { key: "dateOfIssue", label: "Date of Isssue" },
      { key: "address", label: "Address" },
      { key: "name", label: "Name" },
      { key: "bloodGroup", label: "Blood Group" },
      { key: "dlState", label: "State" },
      { key: "swdOf", label: "S/D/W of" },
    ],
    PASSPORT: [
      { key: "name", label: "Name" },
      { key: "country", label: "Country" },
      { key: "dateOfBirth", label: "Date of Birth" },
      { key: "dateOfExpiry", label: "Date of Expiry" },
      { key: "docNumber", label: "Document Number" },
      { key: "sex", label: "Sex" },
      { key: "surname", label: "SurName" },
      { key: "type", label: "Type" },
    ],
    CHEQUE: [
      { key: "accountNo", label: "Account Number" },
      { key: "address", label: "Address" },
      { key: "bank", label: "Bank" },
      { key: "branch", label: "Branch" },
      { key: "city", label: "City" },
      { key: "district", label: "District" },
      { key: "ifsc", label: "IFSC" },
      { key: "micr", label: "MICR" },
      { key: "state", label: "State" },
    ],
    VOTERID: [
      { key: "dob", label: "Date Of Birth" },
      { key: "fatherName", label: "Father's Name" },
      { key: "name", label: "Name" },
      { key: "sex", label: "sex" },
      { key: "voterId", label: "Voter Id" }
    ]
  };

  const excludeParseDocType = ["qr", "singleKYCApproval", "image"];

  const renderMultiScannerOptions = () => {
    const onOptionValueChange = (
      record: any,
      value: any,
      key: "mask" | "parse"
    ) => {
      let existingValue = properties && properties.bindVariables[record.bind.value];
      let latestValue = { ...existingValue, [key]: value };
      properties.bindVariables[record.bind.value] = latestValue;

      onChange(properties && properties.bindVariables, `properties.bindVariables`);
    };
    const dataSource = Object.keys(properties && properties.bindVariables).map(
      (bind: any, index: number) => {
        let currentVar = properties && properties.bindVariables[bind];
        return {
          key: index,
          option: currentVar.label,
          bind: currentVar,
        };
      }
    );
    // [
    //     {
    //       key: '1',
    //       name: 'Mike',
    //       age: 32,
    //       address: '10 Downing Street',
    //     },
    //     {
    //       key: '2',
    //       name: 'John',
    //       age: 42,
    //       address: '10 Downing Street',
    //     },
    //   ];

    const columns = [
      {
        title: "Option",
        dataIndex: "option",
        key: "option",
      },
      {
        title: "Parse",
        dataIndex: "parse",
        key: "parse",
        render: (text: any, record: any, index: number) => (
          <Checkbox
            data-test-id="parse"
            checked={properties && properties.bindVariables[record.bind.value].parse}
            disabled={!props.canEdit}
            onChange={(e) =>
              onOptionValueChange(record, e.target.checked, "parse")
            }
          />
        ),
      },
      {
        title: "Mask",
        dataIndex: "mask",
        key: "mask",
        render: (text: any, record: any, index: number) => (
          <Checkbox
            data-test-id="mask"
            checked={properties && properties.bindVariables[record.bind.value].mask}
            disabled={!props.canEdit}
            onChange={(e) =>
              onOptionValueChange(record, e.target.checked, "mask")
            }
          />
        ),
      },
      // {
      //     title: 'Action',
      //     dataIndex: 'action',
      //     key: 'action',
      //     render: () => <a>Delete</a>,
      // }
    ];

    return (
      <Table dataSource={dataSource} columns={columns} pagination={false} />
    );
  };


  const handleScannerTypeChange = (value: "single" | "multiple") => {
    onChange(value === "multiple", "properties.multiple");
  };

  const datePickerValidate = (startDate: string, endDate: string) => {
    return moment(startDate).isBefore(endDate);
  }

  const throwError = (setState: any) => {
    setState(true)
    setTimeout(() => {
      setState(false)
    }, 2000);
  }

  const docType = properties && properties.docType && properties.docType.split('_')[0];
  
  return (
    <div className={style.body + "props-body"}>
      {<React.Fragment>
        {type && !["TabBar"].includes(type) && (
          <Form.Item label="Id" className={"a8-form-item props"}>
            <Input
              data-test-id="property_id"
              placeholder="Id"
              disabled={!props.canEdit}
              className={style.borderRemove}
              value={idValue}
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, "")
                setIdValue(value, () => onChange(value, 'elementId'))
              }}
            />
          </Form.Item>
        )}
        {type &&
          [
            "Select",
            "Input",
            "DatePicker",
            "CheckBox",
            "RadioButton",
            "Uploader",
            "Otp",
            "DocumentCollector",
            "CheckList",
            "StatCounter",
            "PdfViewer",
            "InputGroup",
            "SignaturePad",
            "EmailVerification",
            "Label"
          ].includes(type) && <>{renderBindComponent()}</>}
        {
          type &&
          ![
            "CheckList",
            "DocumentCollector",
            "Table",
            "Container",
            "Image",
            "PdfViewer"
          ].includes(type) && (
            <Form.Item label="label" className={"a8-form-item props"}>
              {
                labelBlur ?
                  <div onClick={() => setLabelBlur(false)}>
                    <I18AutoCompletion
                      dataTestId="property_label"
                      value={labelValue}/></div>
                  :
                  <CustomAutoComplete
                    dataTestId="property_label"
                    disabled={!props.canEdit}
                    placeholder="Label"
                    value={labelValue}
                    onChange={(e: any) => {
                      const value = e;
                      setLabelValue(value, () => onChange(
                        value,
                        type === "TabBar" ? "name" : "properties.label"
                      ))
                    }}
                    onSelect={(e: any) => {
                      setLabelValue(e, () => onChange(e, type === "TabBar" ? "name" : "properties.label"))
                    }}
                    onBlur={() => setLabelBlur(true)}
                  />
              }
            </Form.Item>
          )}

        {type && ["Scanner"].includes(type) && (
          <>
            <Form.Item
              label="Scanner Type"
              className={"a8-form-item props"}
              hasFeedback
            >
              <Radio.Group
                data-test-id="property_scanner_type"
                defaultValue={
                  properties && properties.multiple ? "multiple" : "single"
                }
                disabled={!props.canEdit}
                onChange={(evt: RadioChangeEvent) =>
                  handleScannerTypeChange(evt.target.value)
                }
                buttonStyle="solid"
              >
                <Radio.Button data-test-id="property_scanner_type_single" value="single">Single</Radio.Button>
                <Radio.Button data-test-id="property_scanner_type_multiple" value="multiple">Multiple</Radio.Button>
              </Radio.Group>
            </Form.Item>
            {properties && !properties.multiple ? (
              <>
                {renderBindComponent()}
                <Form.Item
                  label="Document Type"
                  className={"a8-form-item props"}
                >
                  <Select
                    data-test-id="property_select_document_type"
                    placeholder={"Document Type"}
                    defaultValue={properties.docType}
                    style={{ width: "100%" }}
                    className={style.borderRemove}
                    disabled={!props.canEdit}
                    onChange={async (e: any) => {
                      await onChange(e, "properties.docType");
                      await onChange(false, "properties.parse");
                      await onChange(false, "properties.isParseBindVar");
                      await onChange(null, "properties.parseBindVar");
                    }}
                  >
                    {scannerOptions.map((x) => (
                      <Option data-test-id={`properties_scanner_${x.label}`} label={x.value} key={x.value}>
                        {x.label}
                      </Option>
                    ))}
                    {/* {[
                        "PAN",
                        "AADHAR_FRONT",
                        "AADHAR_BACK",
                        "DL",
                        "CHEQUE",
                        "PASSPORT",
                        "VOTERID",
                        "QR",
                        "PDF",
                        "IMG",
                      ].map((type: string, key: number) => (
                        <Option data-test-id="property_document_type" key={key} value={type}>
                          {type}
                        </Option>
                      ))} */}
                  </Select>
                </Form.Item>
                {properties && properties.docType && excludeParseDocType && excludeParseDocType.indexOf(docType) === -1 && (
                  <>
                    <Divider />
                    <Form.Item label="Parse" className={"a8-form-item props"}>
                      <Switch
                        data-test-id="property_parse"
                        checked={properties && properties.parse}
                        disabled={!props.canEdit}
                        onChange={async (e) => {
                          await onChange(false, "properties.isParseBindVar");
                          await onChange(e, "properties.parse");
                        }}
                      />
                    </Form.Item>
                  </>
                )}
              </>
            ) : (
              <Form.Item label="Document Type" className={"a8-form-item props"}>
                <Select
                  data-test-id="property_scanner_multiple"
                  mode="multiple"
                  style={{ width: "100%" }}
                  disabled={!props.canEdit}
                  className={style.borderRemove}
                  placeholder="Please select"
                  defaultValue={
                    properties && properties.bindVariables &&
                    Object.keys(properties && properties.bindVariables).map(
                      (x: any) => properties && properties.bindVariables[x].value
                    )
                  }
                  onChange={handleMultipleScannerBind}
                >
                  {scannerOptions.map((x) => (
                    <Option data-test-id={`properties_multi_scanner_${x.value}`} label={x.value} key={x.value}>
                      {x.label}
                    </Option>
                  ))}
                </Select>

                {properties && properties.bindVariables &&
                  Object.keys(properties && properties.bindVariables).length > 0 &&
                  renderMultiScannerOptions()}
              </Form.Item>
            )}
            {properties && docType && (
              <>
                {properties && properties.parse === true && (
                  <Form.Item label="Parse Bind Variables" className={"a8-form-item props"}>
                    <Switch
                      data-test-id="property_parse_bind_variables"
                      defaultChecked={properties && properties.isParseBindVar}
                      disabled={!props.canEdit}
                      onChange={async (e) => {
                        onChange(e, "properties.isParseBindVar");
                      }}
                    ></Switch>
                  </Form.Item>
                )}
                {properties && properties.parse === true && properties.isParseBindVar === true && docType && ParseBindVar[docType.toUpperCase()] ? (
                  <Form.Item>
                    {properties.docType &&
                      ParseBindVar[docType.toUpperCase()].map((x: any) => {
                        return <Form.Item label={x.label} className={"a8-form-item props"}>
                          <Input
                            data-test-id={`parse_bind_var_${x.key}`}
                            key={x.key}
                            className={style.borderRemove}
                            title="special characters and space are not allowed"
                            value={parseBindVar && parseBindVar[`${docType.toLowerCase()}_${x.key}`]}
                            disabled={!props.canEdit}
                            onChange={(e) => {
                              const value = e.target.value
                              if (value.length === 0 || value.match("^[a-zA-Z_]+[a-zA-Z0-9_]*$")) {
                                const stateVal = {
                                  ...parseBindVar,
                                  [`${docType.toLowerCase()}_${x.key}`]: value
                                }
                                setParseBindVar(stateVal, () =>
                                  onChange(value, `properties.parseBindVar.${docType.toLowerCase()}_${x.key}`)
                                )
                              }
                            }}
                          ></Input>
                        </Form.Item>
                      })}
                  </Form.Item>
                ) : null}
                {properties && properties.parse === true && (
                  <div>
                    <div className={style.propertiesLabelContainer}>Parser Bind Handler</div>
                    <div data-test-id="parser_bind_handler" className={style.codeContainer} onClick={() => openChangeModal("onParseBindHandler")}>
                      {properties && properties.onParseBindHandler && properties.onParseBindHandler!.fun
                        ? properties.onParseBindHandler!.fun
                        : `async function main(value) {
                                   // Start of editable area

                                   // End of editable area
                               }`}
                    </div>
                  </div>
                )}
                <Divider />
              </>
            )}
          </>
        )}

        {
          type &&
          ![
            "Table",
            "Container",
            "Section",
            "Button",
            "Image",
            "StatCounter",
            "Label",
            "TabBar",
            "PdfViewer"
          ].includes(type) && (
            <Form.Item label="Required" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_required"
                checked={properties && properties.required}
                disabled={!props.canEdit}
                onChange={async (e) => {
                  onChange(e, "properties.required");
                }}
              />
            </Form.Item>
          )}

        {type && ["CheckList"].includes(type) && (
          <>
            <Form.Item label="Key Title" className={"a8-form-item props"}>
              <Input
                data-test-id="property_key_title"
                placeholder="Key Title"
                className={style.borderRemove}
                disabled={!props.canEdit}
                value={keyTitleValue}
                onChange={(e) => {
                  const value = e.target.value
                  setKeyTitleValue(value, () => onChange(value, 'properties.keyTitle'))
                }}
              />
            </Form.Item>
            <Form.Item label="Value Title" className={"a8-form-item props"}>
              <Input
                data-test-id="property_value_title"
                placeholder="Value Title"
                className={style.borderRemove}
                disabled={!props.canEdit}
                value={valueTitleValue}
                onChange={(e) => {
                  const value = e.target.value
                  setValueTitleValue(value, () => onChange(value, 'properties.valueTitle'))
                }}
              />
            </Form.Item>
          </>
        )}
        {
          type &&
          ["Select", "Input", "DatePicker", "InputGroup"].includes(
            type
          ) &&
          !(properties && properties.rangePicker) && (
            <Form.Item label="placeholder" className={"a8-form-item props"}>
              <Input
                data-test-id="property_placeholder"
                placeholder="Placeholder"
                className={style.borderRemove}
                value={placeholderValue}
                disabled={!props.canEdit}
                onChange={(e) => {
                  const value = e.target.value
                  setPlaceholderValue(value, () => onChange(value, "properties.placeholder"))
                }}
              />
            </Form.Item>
          )}
        {
          type &&
          ["DatePicker"].includes(type) && properties &&
          properties.rangePicker && (
            <>
              <Form.Item label="placeholder" className={"a8-form-item props"}>
                <Input
                  data-test-id="property_placeholder"
                  placeholder="placeholder"
                  className={style.borderRemove}
                  value={datePlaceholderValue}
                  disabled={!props.canEdit}
                  onChange={(e) => {
                    const value = e.target.value
                    setDatePlaceholderValue(value, () => {
                      onChange(
                        [
                          value,
                          Array.isArray(properties && properties.placeholder)
                            ? properties.placeholder[1]
                            : "End Date",
                        ],
                        "properties.placeholder"
                      )
                    })
                  }}
                />
              </Form.Item>
              <Form.Item label="placeholder" className={"a8-form-item props"}>
                <Input
                  data-test-id="property_placeholder"
                  placeholder="placeholder"
                  className={style.borderRemove}
                  value={datePlaceholderToValue}
                  disabled={!props.canEdit}
                  onChange={(e) => {
                    const value = e.target.value
                    setDatePlaceholderToValue(value, () => {
                      onChange(
                        [
                          Array.isArray(properties && properties.placeholder)
                            ? properties.placeholder[0]
                            : "Start Date",
                          value,
                        ],
                        "properties.placeholder"
                      )
                    })
                  }}
                />
              </Form.Item>
            </>
          )}
        {
          <>
            {
              type && ["Section"].includes(type) && type && (
                <>
                  <Form.Item label="Collapsable" className={"a8-form-item props"}>
                    <Switch
                      data-test-id="collapsable_section"
                      disabled={!props.canEdit}
                      checked={
                        properties &&
                          properties.collapsable === true
                          ? true
                          : false
                      }
                      onChange={async (e) => {
                        await onChange(e, "properties.collapsable");
                        if (!e) {
                          await onChange(e, "properties.defaultCollapse")
                        }
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="Read Only" className={"a8-form-item props"}>
                    <Switch
                      data-test-id="read_only_state"
                      disabled={!props.canEdit}
                      checked={properties && properties.readOnly}
                      onChange={async (e) => {
                        onChange(e, "properties.readOnly");
                      }}
                    />
                  </Form.Item>
                  {properties && properties.collapsable &&
                    <Form.Item label="Collapsed By Default" className={"a8-form-item props"}>
                      <Switch
                        data-test-id="default_collapse_state"
                        disabled={!props.canEdit}
                        checked={properties && properties.defaultCollapse}
                        onChange={async (e) => {
                          onChange(e, "properties.defaultCollapse");
                        }}
                      />
                    </Form.Item>
                  }
                </>
              )
            }
          </>
        }
        {type && !["TabBar"].includes(type) && (
          <>
            <Form.Item label="Visible" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_visible"
                disabled={!props.canEdit}
                checked={
                  properties &&
                    properties.visibility &&
                    properties.visibility.checked === false
                    ? false
                    : true
                }
                onChange={async (e) => {
                  onChange(e, "properties.visibility.checked");
                }}
              />
            </Form.Item>
            <Form.Item
              label={
                `${properties &&
                  properties.visibility &&
                  properties.visibility.checked === false
                  ? "Show"
                  : "Hide"
                } On`
              }
              className={"a8-form-item props"}
            >
              <Input
                data-test-id="property_hide_show"
                disabled={!props.canEdit}
                placeholder="eg: bindParam === 'value'"
                className={style.borderRemove}
                value={visibilityValue}
                onChange={(e) => {
                  const value = e.target.value
                  setVisibilityValue(value, () => onChange(value, "properties.visibility.condition"))
                }}
              />
            </Form.Item>
          </>
        )}
        {type && ["DatePicker"].includes(type) && (
          <>
            <Form.Item label="Format" className={"a8-form-item props"}>
              <Input
                data-test-id="property_format"
                disabled={!props.canEdit}
                placeholder="Format"
                className={style.borderRemove}
                value={formatValue}
                onChange={(e) => {
                  const value = e.target.value
                  setFormatValue(value, () => onChange(value, "properties.format"))
                }}
              />

              {/* <Switch
                                            defaultChecked={properties.rangePicker}
                                            onChange={async (e) => {
                                                !e && await onChangeAsync("Select Date", 'properties.placeholder')
                                                onChange(e, 'properties.rangePicker')
                                            }

                                            } /> */}
            </Form.Item>
            <Form.Item label="RangePicker" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_range_picker"
                disabled={!props.canEdit}
                checked={properties && properties.rangePicker}
                onChange={(e) => {
                  !e &&
                    (onChange("Select Date", "properties.placeholder"));
                  e && (onChange(false, "properties.showDate"));
                  onChange(e, "properties.rangePicker");
                }}
              />
            </Form.Item>
            <Form.Item label="Show Time" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_show_time"
                checked={properties && properties.showTime}
                disabled={!props.canEdit}
                onChange={(e) => onChange(e, "properties.showTime")}
              />
            </Form.Item>
            <Form.Item label="show Date" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_show_date"
                checked={properties && properties.showDate}
                disabled={!props.canEdit}
                onChange={(e) => {
                  e && (onChange(false, "properties.rangePicker"));
                  onChange(e, "properties.showDate");
                }}
              />
            </Form.Item>
            <div>
              {properties && properties.showDate && <Form.Item
                validateStatus={fromTypeError ? "error" : undefined}
                help={fromTypeError ? "From Date Should Be Before Then To Date" : ""}
                label="From" className={"a8-form-item props"}>
                <Select
                  data-test-id="property_date_select_from"
                  // defaultValue={"none"}
                  value={properties && properties.FromType}
                  style={{ width: "100%" }}
                  disabled={!props.canEdit}
                  className={""}
                  onChange={async (e: any) => {
                    if (properties && properties.ToType === "specificdate" && properties.ToValue && e === "today") {
                      if (datePickerValidate(moment().format("YYYY-MM-DD"), properties && properties.ToValue)) {
                        await onChangeAsync(e, "properties.FromType");
                        await onChangeAsync("", "properties.FromValue")
                        await onChangeAsync(moment().format("YYYY-MM-DD"), "properties.FromDate");
                        // setFromTypeError(false)
                      } else {
                        throwError(setFromTypeError)
                        // setFromTypeError(true)
                      }
                    } else {
                      // setFromTypeError(false)
                      e === "today" && await onChangeAsync(moment().format("YYYY-MM-DD"), "properties.FromDate");
                      await onChangeAsync(e, "properties.FromType");
                      await onChangeAsync("", "properties.FromValue")
                      e !== "today" && await onChangeAsync("", "properties.FromDate");
                    }

                  }}
                >
                  <Option data-test-id="property_specificdate" value="specificdate">Specific Date</Option>
                  {properties && properties.ToType !== "today" && <Option data-test-id="property_today" value="today">Today</Option>}
                  <Option data-test-id="property_days" value="days">No of Days Before Today</Option>
                  <Option data-test-id="property_months" value="months">No of Months Before Today</Option>
                  <Option data-test-id="property_years" value="years">No of Years Before Today</Option>
                  <Option data-test-id="property_none" value="none">None</Option>
                </Select>
              </Form.Item>
              }
              {properties && properties.showDate && properties.FromType === "specificdate" &&
                <Form.Item
                  className={'a8-form-item'}
                  label={'Select Specific Date'}
                  validateStatus={fromDatePickerError ? "error" : undefined}
                  help={fromDatePickerError ? "From Date Should Be Before Then To Date" : ""}
                >
                  <DatePicker
                    data-test-id="property_select_date"
                    value={properties && properties.FromValue ? moment(properties.FromValue) : undefined}
                    disabled={!props.canEdit}
                    onChange={
                      async (e: any) => {
                        if (e) {
                          if ((properties && properties.ToType === "specificdate" && properties.ToValue && datePickerValidate(e.format("YYYY-MM-DD"), properties.ToValue))
                            || (properties && properties.ToType === "today" && datePickerValidate(e.format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")))
                            || (properties && properties.ToType === "days" && properties.ToValue && datePickerValidate(e.format("YYYY-MM-DD"), moment().add(properties.ToValue, 'days').format("YYYY-MM-DD")))
                            || (properties && properties.ToType === "months" && properties.ToValue && datePickerValidate(e.format("YYYY-MM-DD"), moment().add(properties.ToValue, 'months').format("YYYY-MM-DD")))
                            || (properties && properties.ToType === "years" && properties.ToValue && datePickerValidate(e.format("YYYY-MM-DD"), moment().add(properties.ToValue, 'years').format("YYYY-MM-DD")))
                            || (properties && properties.ToType === "none")
                          ) {
                            await onChangeAsync(e.format("YYYY-MM-DD"), "properties.FromValue")
                            await onChangeAsync(e.format("YYYY-MM-DD"), "properties.FromDate");
                          } else if (properties && properties.ToValue !== "") {
                            throwError(setFromDatePickerError)
                          } else {
                            await onChangeAsync(e.format("YYYY-MM-DD"), "properties.FromDate");
                            await onChangeAsync(e.format("YYYY-MM-DD"), "properties.FromValue")
                          }
                        } else {
                          await onChangeAsync("", "properties.FromDate");
                          await onChangeAsync("", "properties.FromValue")

                        }

                      }
                    }

                    style={{ width: "100%" }}
                    placeholder={'Select Date'} />
                </Form.Item>
              }
              {properties && properties.showDate && properties.FromType && (properties.FromType === "days" || properties.FromType === "months" || properties.FromType === "years") &&
                <Form.Item
                  className={'a8-form-item'}
                  label={`No of ${properties && properties.FromType} Before Today`}
                  validateStatus={fromNumberError ? "error" : undefined}
                  help={fromNumberError ? "To Date Should Be After Then From Date" : ""}
                >
                  <InputNumber
                    data-test-id="property_before_today"
                    value={properties && properties.FromValue}
                    disabled={!props.canEdit}
                    onChange={
                      async (e: any) => {

                        if (properties && properties.ToType === "specificdate" && properties.ToValue) {
                          if ((properties && properties.FromType === "days" && datePickerValidate(moment().subtract(e, 'days').format("YYYY-MM-DD"), properties.ToValue))
                            || (properties && properties.FromType === "months" && datePickerValidate(moment().subtract(e, 'months').format("YYYY-MM-DD"), properties.ToValue))
                            || (properties && properties.FromType === "years" && datePickerValidate(moment().subtract(e, 'years').format("YYYY-MM-DD"), properties.ToValue))
                            || (e === "")
                          ) {
                            await onChangeAsync(e, "properties.FromValue")
                            await onChangeAsync(moment().subtract(e, properties && properties.FromType).format("YYYY-MM-DD"), "properties.FromDate");
                            setFromNumberError(false)
                          } else {
                            setFromNumberError(true)
                            // throwError(setFromNumberError)
                          }
                        } else {
                          setFromNumberError(false)
                          await onChangeAsync(e, "properties.FromValue")
                          await onChangeAsync(moment().subtract(e, properties && properties.FromType).format("YYYY-MM-DD"), "properties.FromDate");
                        }
                      }}
                    parser={(string: any) => {
                      if (string && (!isNaN(parseFloat(string)) && !isNaN(string - 0))) {
                        return string
                      } else {
                        let trimedString = string.match(/\d/g)
                        return trimedString ? trimedString.join("") : undefined
                      }
                    }}
                    style={{ width: "100%" }} placeholder="selectNumber" />
                </Form.Item>
              }
              {properties && properties.showDate &&
                <Form.Item
                  label="To"
                  validateStatus={toTypeError ? "error" : undefined}
                  help={toTypeError ? "To Date Should Be After Then From Date" : ""}
                  className={"a8-form-item props"}
                >
                  <Select
                    data-test-id="property_date_select_to"
                    value={properties && properties.ToType}
                    style={{ width: "100%" }}
                    className={""}
                    disabled={!props.canEdit}
                    onChange={async (e: any) => {
                      if (properties && properties.FromType === "specificdate" && e === "today" && properties.FromValue) {
                        if (datePickerValidate(properties && properties.FromValue, moment().format("YYYY-MM-DD"))) {
                          await onChangeAsync(e, "properties.ToType");
                          await onChangeAsync("", "properties.ToValue");
                          await onChangeAsync(moment().format("YYYY-MM-DD"), "properties.ToDate");
                        } else {
                          throwError(setToTypeError)
                        }
                      } else {
                        e === "today" && await onChangeAsync(moment().format("YYYY-MM-DD"), "properties.ToDate");
                        e !== "today" && await onChangeAsync("", "properties.ToDate");
                        await onChangeAsync(e, "properties.ToType");
                        await onChangeAsync("", "properties.ToValue");
                      }
                    }}
                  >
                    <Option value="specificdate">specific date</Option>
                    {properties && properties.FromType !== "today" && <Option value="today">Today</Option>}
                    <Option data-test-id="property_days" value="days">No of Days After Today</Option>
                    <Option data-test-id="property_months" value="months">No Months After Today</Option>
                    <Option data-test-id="property_years" value="years">No Years After Today</Option>
                    <Option data-test-id="property_value" value="none">None</Option>
                  </Select>
                </Form.Item>
              }
              {properties && properties.showDate && properties.ToType === "specificdate" &&
                <Form.Item
                  className={'a8-form-item'}
                  label={'Select Specific Date'}
                  validateStatus={toDatePickerError ? "error" : undefined}
                  help={toDatePickerError ? "To Date Should Be After Then From Date" : ""}
                >
                  <DatePicker
                    data-test-id="property_specific_date"
                    style={{ width: "100%" }}
                    value={properties && properties.ToValue ? moment(properties.ToValue) : undefined}
                    disabled={!props.canEdit}
                    onChange={
                      async (e: any) => {
                        if (e) {
                          if ((properties && properties.FromType === "specificdate" && properties.FromValue && datePickerValidate(properties && properties.FromValue, e.format("YYYY-MM-DD")))
                            || (properties && properties.FromType === "today" && datePickerValidate(moment().format("YYYY-MM-DD"), e.format("YYYY-MM-DD")))
                            || (properties && properties.FromType === "days" && properties.FromValue && datePickerValidate(moment().subtract(properties && properties.FromValue, 'days').format("YYYY-MM-DD"), e.format("YYYY-MM-DD")))
                            || (properties && properties.FromType === "months" && properties.FromValue && datePickerValidate(moment().subtract(properties && properties.FromValue, 'months').format("YYYY-MM-DD"), e.format("YYYY-MM-DD")))
                            || (properties && properties.FromType === "years" && properties.FromValue && datePickerValidate(moment().subtract(properties && properties.FromValue, 'years').format("YYYY-MM-DD"), e.format("YYYY-MM-DD")))
                            || (properties && properties.FromType === "none") || (properties && properties.FromType !== "today" && properties.FromValue === "")
                          ) {
                            await onChangeAsync(e.format("YYYY-MM-DD"), "properties.ToValue")
                            await onChangeAsync(e.format("YYYY-MM-DD"), "properties.ToDate");
                          } else if (properties.FromType === "today" || properties.FromValue !== "") {
                            throwError(setToDatePickerError)
                          }
                        } else {
                          await onChangeAsync("", "properties.ToValue")
                          await onChangeAsync("", "properties.ToDate");
                        }
                      }
                    } placeholder={'Select Date'} />
                </Form.Item>
              }
              {properties && properties.showDate && properties.ToType && (properties.ToType === "days" || properties.ToType === "months" || properties.ToType === "years") &&
                <Form.Item
                  className={'a8-form-item'}
                  label={`No of ${properties && properties.ToType}  After Today`}
                  validateStatus={toNumberError ? "error" : undefined}
                  help={toNumberError ? "To Date Should Be After Then From Date" : ""}
                >
                  <InputNumber
                    data-test-id="property_after_today"
                    value={properties && properties.ToValue}
                    disabled={!props.canEdit}
                    onChange={
                      async (e: any) => {
                        if (properties && properties.FromType === "specificdate" && properties.FromValue) {
                          if ((properties && properties.ToType === "days" && datePickerValidate(properties.FromValue, moment().add(e, 'days').format("YYYY-MM-DD")))
                            || (properties && properties.ToType === "months" && datePickerValidate(properties.FromValue, moment().add(e, 'months').format("YYYY-MM-DD")))
                            || (properties && properties.ToType === "years" && datePickerValidate(properties.FromValue, moment().add(e, 'years').format("YYYY-MM-DD")))
                            || (e === "")
                          ) {
                            setToNumberError(false)
                            await onChangeAsync(e, "properties.ToValue")
                            await onChangeAsync(moment().add(e, properties && properties.ToType).format("YYYY-MM-DD"), "properties.ToDate");
                          } else {
                            setToNumberError(true)
                            // throwError(setToNumberError)
                          }
                        } else {
                          setToNumberError(false)
                          await onChangeAsync(moment().add(e, properties && properties.ToType).format("YYYY-MM-DD"), "properties.ToDate");
                          await onChangeAsync(e, "properties.ToValue")
                        }
                      }}
                    parser={(string: any) => {

                      if (string && (!isNaN(parseFloat(string)) && !isNaN(string - 0))) {
                        return string
                      } else {
                        let trimedString = string.match(/\d/g)
                        return trimedString ? trimedString.join("") : undefined
                      }

                    }}
                    style={{ width: "100%" }} placeholder="selectNumber" />

                </Form.Item>
              }
            </div>
          </>
        )}

        {type && ["Uploader"].includes(type) && (
          <React.Fragment>
            <Form.Item label="Multi select" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_multi_select"
                checked={properties && properties.multiple}
                disabled={!props.canEdit}
                onChange={async (e) => {
                  onChange(e, "properties.multiple");
                }}
              />
            </Form.Item>
            {/* <Form.Item label="Read Only" className={'a8-form-item props'}>
                                        <Switch
                                            checked={properties.multiple}
                                            onChange={async (e) => {
                                                onChange(e, 'properties.multiple')
                                            }} />
                                    </Form.Item> */}
          </React.Fragment>
        )}
        {type &&
          properties &&
          !properties.layout &&
          ![
            "CheckList",
            "DocumentCollector",
            "Section",
            "TabBar",
            "Container",
          ].includes(type) && (
            <Form.Item label="size" className={"a8-form-item props"}>
              <Select
                data-test-id="property_size"
                defaultValue={json.size}
                style={{ width: "100%" }}
                className={style.borderRemove}
                disabled={!props.canEdit}
                onChange={(e: any) => onChange(e, "size")}
              >
                <Option data-test-id="property_size_small" value="col-md-4">Small</Option>
                <Option data-test-id="property_size_medium" value="col-md-6">Medium</Option>
                <Option data-test-id="property_size_Large" value="col-md-12">Large</Option>
              </Select>
            </Form.Item>
          )}
        {type && type.includes("TabBar") && (
          <>
            {selectedAppType !== "a8assist" && (
              <>
                <Form.Item label="Tab key" className={"a8-form-item props"}>
                  <Input
                    data-test-id="property_tab_key"
                    placeholder="Tab key"
                    className={style.borderRemove}
                    value={tabKeyValue}
                    disabled={!props.canEdit}
                    onChange={(e) => {
                      const value = e.target.value;
                      setTabKeyValue(value, () => onChange(value, "tabKey"))
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Visibility"
                  className={"a8-form-item props"}
                >
                  <Switch
                    data-test-id="property_visibility"
                    checked={json.visibility}
                    disabled={!props.canEdit}
                    onChange={async (e) => {
                      onChange(e, "visibility");
                    }}
                  />
                </Form.Item>
              </>
            )}

            {selectedAppType === "a8assist" && (
              <Form.Item label="Background" className={"a8-form-item props"}>
                <Switch
                  data-test-id="property_tab_bg_img"
                  checked={tabBgImage}
                  checkedChildren={"image"}
                  unCheckedChildren={"color"}
                  defaultChecked={tabBgImage}
                  disabled={!props.canEdit}
                  onChange={(e) => setTabBgImage(e)}
                />
                {tabBgImage ? (
                  <div className="clearfix">
                    <Upload
                      action=""
                      listType="picture-card"
                      showUploadList={false}
                      disabled={!props.canEdit}
                      onChange={handleBgImageChange}
                    >
                      {selectedBgImage ? (
                        <div>
                          <img src={selectedBgImage} alt="" />
                        </div>
                      ) : (
                        <div>
                          <Icon type="plus" />
                          <div className="ant-upload-text">Upload</div>
                        </div>
                      )}
                    </Upload>
                  </div>
                ) : (
                  <div className={style.colors}>
                    <div
                      className={style.custom}
                      style={
                        json.backgroundColor
                          ? { backgroundColor: json.backgroundColor }
                          : {}
                      }
                    >
                      <Picker />
                      <input data-test-id="bg_color" type="color" onBlur={handleBgColor} />
                    </div>
                  </div>
                )}
              </Form.Item>
            )}

            <div className={style.propertiesLabelContainer}>On load</div>
            <div
              data-test-id="on load"
              className={style.codeContainer}
              onClick={() => openChangeModal("onLoad")}
            >
              {properties &&
                properties.onLoad &&
                properties.onLoad!.fun
                ? properties.onLoad!.fun
                : `async function main() {
                    // Start of editable area

                    // End of editable area
                }`}
            </div>

            <div className={style.propertiesLabelContainer}>On Tab Switch</div>
            <div
              data-test-id="on load"
              className={style.codeContainer}
              onClick={() => openChangeModal("onTabSwitch")}
            >
              {onTabSwitchCode}
            </div>
            {
              formData?.[0]?.tabKey === json.tabKey && (
                <>
                  <div className={style.propertiesLabelContainer}>On Task Event</div>
                  <div
                    data-test-id="on task event"
                    className={style.codeContainer}
                    onClick={() => openChangeModal("onTaskEvent")}
                  >
                    {onTaskEventCode}
                  </div>
                </>
              )
            }
          </>
        )}
        {
          type &&
          [
            "Input",
            "InputGroup",
            "Select",
            "DatePicker",
            "CheckBox",
            "RadioButton",
            "EmailVerification",
          ].includes(type) && (
            <Form.Item label="Read Only" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_read_only"
                checked={properties && properties.readOnly}
                disabled={!props.canEdit}
                onChange={async (e) => {
                  onChange(e, "properties.readOnly");
                }}
              />
            </Form.Item>
          )}
        {type && ["Button"].includes(type) && (
          <>
            <Form.Item label="Button Height" className={"a8-form-item props"}>
              <Select
                data-test-id="property_button_size"
                defaultValue={properties && properties.buttonSize}
                style={{ width: "100%" }}
                className={style.borderRemove}
                disabled={!props.canEdit}
                onChange={(e: any) => onChange(e, "properties.buttonSize")}
              >
                <Option data-test-id="property_button_size_small" value="small">Small</Option>
                <Option data-test-id="property_button_size_medium" value="default">Medium</Option>
                <Option data-test-id="property_button_size_large" value="large">Large</Option>
              </Select>
            </Form.Item>

            <Form.Item label="Type" className={"a8-form-item props"}>
              <Select
                data-test-id="property_button_type"
                defaultValue={properties && properties.buttonType}
                style={{ width: "100%" }}
                className={style.borderRemove}
                disabled={!props.canEdit}
                onChange={(e: any) => onChange(e, "properties.buttonType")}
              >
                <Option data-test-id="property_button_type_default" value="default">Default</Option>
                <Option data-test-id="property_button_type_primary" value="primary">Primary</Option>
                <Option data-test-id="property_button_type_dashed" value="dashed">Dashed</Option>
                <Option data-test-id="property_button_type_danger" value="danger">Danger</Option>
                <Option data-test-id="property_button_type_link" value="link">Link</Option>
              </Select>
            </Form.Item>

            <Form.Item label="Shape" className={"a8-form-item props"}>
              <Select
                data-test-id="property_button_shape"
                defaultValue={properties && properties.buttonShape}
                style={{ width: "100%" }}
                className={style.borderRemove}
                disabled={!props.canEdit}
                onChange={(e: any) => onChange(e, "properties.buttonShape")}
              >
                <Option data-test-id="property_button_shape_circle" value="circle">Circle</Option>
                <Option data-test-id="property_button_shape_circle_outline" value="circle-outline">Circle outline</Option>
                <Option data-test-id="property_button_shape_round" value="round">Round</Option>
              </Select>
            </Form.Item>

            <Form.Item label="Disabled" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_disabled"
                checked={properties && properties.disabled}
                disabled={!props.canEdit}
                onChange={async (e) => {
                  onChange(e, "properties.disabled");
                }}
              />
            </Form.Item>

            <div className={style.propertiesLabelContainer}>On Click</div>
            <div
              data-test-id="property_onclick"
              className={style.codeContainer}
              onClick={() => openCodeEditorModal()}
            >
              {properties &&
                properties.onClick &&
                properties.onClick!.fun
                ? properties.onClick!.fun
                : `async function main() {
                                                // Start of editable area

                                                // End of editable area
                                            }`}
            </div>
          </>
        )}

        {type === "InputGroup" && (
          <>
            <Form.Item label="Button Text" className={"a8-form-item props"}>
              <Input
                data-test-id="property_button_text"
                placeholder="Button text"
                className={style.borderRemove}
                value={buttonTextValue}
                disabled={!props.canEdit}
                onChange={(e) => {
                  const value = e.target.value
                  setButtonTextValue(value, () => onChange(value, "properties.buttonText"))
                }}
              />
            </Form.Item>
          </>
        )}

        {type === "InputGroup" && (
          <>
            <div className={style.propertiesLabelContainer}>On Click</div>
            <div
              data-test-id="property_input_group_onclick"
              className={style.codeContainer}
              onClick={() => openCodeEditorModal()}
            >
              {properties &&
                properties.onClick &&
                properties.onClick!.fun
                ? properties.onClick!.fun
                : `async function main(value) {
                                                  // Start of editable area

                                                  // End of editable area
                                              }`}
            </div>
          </>
        )}

        {
          type &&
          ![
            "CheckList",
            "DocumentCollector",
            "Scanner",
            "Uploader",
            "Section",
            "TabBar",
            "Button",
            "Label",
            "Table",
            "Container",
            "Image",
            "PdfViewer",
            "StatCounter",
            "EmailVerification",
          ].includes(type) && (
            <>
              <div className={style.propertiesLabelContainer}>On Change</div>
              <div
                data-test-id="property_onchange"
                className={style.codeContainer}
                onClick={() => openChangeModal("onChange")}
              >
                {properties &&
                  properties.onChange &&
                  properties.onChange!.fun
                  ? properties.onChange!.fun
                  : `async function main(value) {
                                                // Start of editable area
                                                
                                                // End of editable area
                                            }`}
              </div>
              {
                type &&
                ![
                  "Select",
                  "DatePicker",
                  "CheckBox",
                  "RadioButton",
                  "Container",
                  "Table",
                  "Image",
                  "PdfViewer",
                  "EmailVerification",
                ].includes(type) && (
                  <>
                    <div className={style.propertiesLabelContainer}>
                      On Blur
                    </div>
                    <div
                      data-test-id="property_onblur"
                      className={style.codeContainer}
                      onClick={() => openChangeModal("onBlur")}
                    >
                      {properties &&
                        properties.onBlur &&
                        properties.onBlur!.fun
                        ? properties.onBlur!.fun
                        : `async function main(value) {
                                            // Start of editable area
                                            
                                            // End of editable area
                                        }`}
                    </div>
                  </>
                )}
            </>
          )}

        {type === "Image" && (
          <>
            <Form.Item label="Image Fill" className={"a8-form-item props"}>
              <Switch
                data-test-id="property_img_fill"
                checked={properties && properties.fillImage}
                disabled={!props.canEdit}
                onChange={async (e) => {
                  onChange(e, "properties.fillImage");
                }}
              />
            </Form.Item>
          </>
        )}

        {type === "StatCounter" && (
          <>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="Background"
                  className={"a8-form-item props"}
                >
                  <ColorPicker
                    data-test-id="property_background"
                    disabled={!props.canEdit}
                    defaultColor={
                      (properties &&
                        properties.theme &&
                        properties.theme.background) || {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1,
                      }
                    }
                    handleSubmit={(color) =>
                      onChange(color, "properties.theme.background")
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Color" className={"a8-form-item props"}>
                  <ColorPicker
                    data-test-id="property_color"
                    disabled={!props.canEdit}
                    defaultColor={
                      (properties &&
                        properties.theme &&
                        properties.theme.color) || {
                        r: 255,
                        g: 0,
                        b: 0,
                        a: 1,
                      }
                    }
                    handleSubmit={(color) =>
                      onChange(color, "properties.theme.color")
                    }
                    className="left"
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}

        {isChangeModalvisible &&
          <TarsLayout
            setCurrentLine={setCurrentLine}
            currentLine={currentLine}
            visibleTars={true}
            tarsModal={tarsModal}
            setTarsModal={setTarsModal}
            value={
              properties &&
                properties[selectedHandlerType] &&
                properties[selectedHandlerType]!.fun
                ? properties[selectedHandlerType]!.fun.startsWith(
                  "async"
                )
                  ? properties[selectedHandlerType]!.fun
                  : "async " + properties[selectedHandlerType]!.fun
                : `async function main(value) {
  // Start of editable area

  // End of editable area
}`
            }
            json={json}
            lang={"javascript"}
            readOnly={!props.canEdit}
            onSave={(value: { source: string; comSource: string }, modalId: boolean) => {
              if (!props.canEdit) return;
              onChange(value.source, `properties.${selectedHandlerType}.fun`);
              if (modalId) {

                setChangeModalVisible(false);
              }
            }}
            height="450px"
            width="98%"
            customdef={functionsdef}
            type="inline"
            saveMessage={{
              enable: true,
              message: "Click handler added",
            }}
            onOk={() => {
              let modalId: number = 7238212;
              let event = new KeyboardEvent("keydown", {
                key: "s",
                code: "KeyS",
                ctrlKey: true,
                detail: modalId,
              });
              document.dispatchEvent(event);
            }}
            editorRef={editorRef} title="CODE EDITOR"
            modalVisibile={isChangeModalvisible}
            canEdit={props.canEdit}
            setModalVisible={setChangeModalVisible}>
          </TarsLayout>
        }
        <Modal
          id="code2"
          dataTestId="code2"
          unmountOnCancel={true}
          visible={visible}
          title="CODE EDITOR"
          onCancel={() => {
            setVisible(false);
          }}
          width={"1000px"}
          key="click-code-editor"
          footer={props.canEdit ? {
            enable: true,
            cancelText: "Close",
            okText: "Save",
            onOk: () => {
              let modalId: number = 7238212;
              let event = new KeyboardEvent("keydown", {
                key: "s",
                code: "KeyS",
                ctrlKey: true,
                detail: modalId,
              });
              document.dispatchEvent(event);
            },
          } : {
            enable: false,
          }}
          style={{ top: '12px' }}
        >
          {functionsdef && (
            <CodeEditor
              data-test-id="properties_code_editor"
              readOnly={!props.canEdit}
              value={
                properties &&
                  properties.onClick &&
                  properties.onClick!.fun
                  ? properties.onClick!.fun
                  : `async function main(${type === "InputGroup" ? "value" : ""
                  }) { 
  // Start of editable area
  
  // End of editable area
}`
              }
              json={json}
              lang={"javascript"}
              onSave={(
                value: { source: string; comSource: string },
                modalId: boolean
              ) => {
                if (!props.canEdit) return;
                onChange(value.source, "properties.onClick.fun");

                if (modalId) {

                  setVisible(false);
                }
              }}
              height="450px"
              customdef={functionsdef}
              type="inline"
              saveMessage={{
                enable: true,
                message: "Click handler added",
              }}
            />
          )}
        </Modal>
      </React.Fragment>
      }
    </div>
  );
};
